export default function uniqArrayUtil (array) {
  const uniqueArray = []
  for (const item of array) {
    if (!uniqueArray.includes(item)) {
      uniqueArray.push(item)
    }
  }
  return uniqueArray
}
